import React, { Suspense } from 'react'
const Chart = React.lazy(() => import('../components/BigChart'))

export default function SomePage() {
  return (
    <div>
      <h1>Some Page</h1>
      <Suspense fallback={<div>Loading chart...</div>}>
        <Chart />
      </Suspense>
    </div>
  )
}